import React, { useEffect, useState } from 'react';
import {
  Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Button, Modal, Box, TextField, Typography,
  Paper,
  IconButton
} from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2';
import Edit from "@mui/icons-material/Edit";
import { PartnerArrowIcon } from '../../res/NewWebIcons';

const API_URL = 'https://api.ipaisa.co.in/myapp/admin';
const getToken = () => sessionStorage.getItem("jwtToken");

const SetPayoutLimit = () => {
  const [limits, setLimits] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedLimit, setSelectedLimit] = useState({ transactionType: '', limitAmount: '' });

  useEffect(() => {
    fetchLimits();
  }, []);

  const fetchLimits = async () => {
    try {
      const response = await axios.get(`${API_URL}/get_limit`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      setLimits(response.data.body.data || []);
    } catch (error) {
      console.error('Error fetching limits:', error);
      setLimits([]);
    }
  };

  const handleEdit = (limit) => {
    setSelectedLimit(limit);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async () => {
    try {
      const response = await axios.put(`${API_URL}/update_payout_limit`, {
        transactionType: selectedLimit.transactionType,
        limitAmount: selectedLimit.limitAmount
      }, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'Content-Type': 'application/json'
        }
      });
      fetchLimits(); // Refresh data after update
      handleClose();

      Swal.fire({
        title: 'Success',
        html: `<b>Transaction Type:</b> ${response.data.body.data.transactionType}<br/><b>Limit Amount:</b> ${response.data.body.data.limitAmount}<br/><br/>${response.data.body.message}`,
        icon: 'success',
        confirmButtonText: 'OK'
      });
    } catch (error) {
      console.error('Error updating limit:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to update payout limit.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };


  return (
    <Box sx={{ padding: 3, marginTop: "5%"}}>
            <Grid>
              <Grid
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1%",
                  justifyContent: "start",
                }}
              >
                <Typography
                  color="textSecondary"
                  style={{ fontFamily: "sans-serif", fontSize: "13px" }}
                >
                  Balance
                </Typography>
                <PartnerArrowIcon />
                <Typography
                  color="textSecondary"
                  style={{ fontFamily: "sans-serif", fontSize: "13px" }}
                >
                  Set Payout Limits
                </Typography>
              </Grid>
      
              <Grid
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "1%",
                }}
              >
                <Grid>
                  <Typography
                    style={{
                      fontWeight: "bold",
                      fontFamily: "sans-serif",
                      fontSize: "19px",
                      color: "#343C6A",
                    }}
                  >
                    Set Payout Limits
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
      <Grid item xs={12}>
      <TableContainer component={Paper} sx={{ marginTop: 2, borderRadius: 2, boxShadow: 3, overflowX: "auto" }}>
        <Table>
            <TableHead sx={{ backgroundColor: "#027BFE" }}>
              <TableRow>
                <TableCell sx={{color:'white'}}>Sr No.</TableCell>
                <TableCell sx={{color:'white'}}>Transaction Type</TableCell>
                <TableCell sx={{color:'white'}}>Limit Amount</TableCell>
                <TableCell sx={{color:'white'}}>Change Limit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {limits.length > 0 ? (
                limits.map((limit, index) => (
                  <TableRow key={limit.id}
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#C1E0FB",
                  }}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{limit.transactionType}</TableCell>
                    <TableCell>{limit.limitAmount}</TableCell>
                    <TableCell>
                      <Button onClick={() => handleEdit(limit)}>
                        <IconButton>
                          <Edit sx={{color:'#027BFE'}}/>
                        </IconButton>
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">No data available</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Modal open={open} onClose={handleClose}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', 
          bgcolor: 'background.paper', boxShadow: 24, p: 4, width: 300 }}>
          <Typography variant="h6">Edit Payout Limit</Typography>
          <TextField fullWidth margin="normal" label="Transaction Type" value={selectedLimit.transactionType} disabled />
          <TextField
            fullWidth
            margin="normal"
            label="Limit Amount"
            type="number"
            value={selectedLimit.limitAmount}
            onChange={(e) => setSelectedLimit({ ...selectedLimit, limitAmount: e.target.value })}
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button variant="outlined" color="secondary" onClick={handleClose}>Cancel</Button>
            <Button variant="contained" color="primary" onClick={handleSave}>Save</Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default SetPayoutLimit;
